import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    salutation: {
      validations: []
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    startTime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Salutation',
            mapping: 'salutation',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone*',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email',
            customClasses: ['no-label']
          },
        ]
      },


      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'eventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice-nolabel',
            size: 'Medium',
            label: 'Start Time',
            options: [
              { label: '6:00 AM', value: '06:00:00' },
              { label: '6:30 AM', value: '06:30:00' },
              { label: '7:00 AM', value: '07:00:00' },
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
              { label: '2:30 AM', value: '02:30:00' },
              { label: '3:00 AM', value: '03:00:00' },
              { label: '3:30 AM', value: '03:30:00' },
              { label: '4:00 AM', value: '04:00:00' },
              { label: '4:30 AM', value: '04:30:00' },
              { label: '5:00 AM', value: '05:00:00' },
              { label: '5:30 AM', value: '05:30:00' }
            ],
            mapping: 'startTime',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Event Details',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Boulevard Contact Us Form',
    formId: '474',
    clientKey: '4DFA0948-7BD1-4F74-9E4C-727308E36F41',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/theboulevard/form_structure.js